module.exports = __webpack_public_path__ + "russierenouvelables/img/team-design.a88d32fc.webp";